// src/modules/callSync/api.js
import API from '../../services/api';

const base = '/call-sync';

// ── Calls ──
// The Idempotency-Key is what stops a double-click, a retried request or a
// flaky connection making the rep's phone dial the customer twice.
export const startCall = (data, idempotencyKey) => API.post(`${base}/calls/start`, data, {
  headers: idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : {},
});
export const fetchCall = (callId) => API.get(`${base}/calls/${callId}`);
export const fetchCallStatus = (callId) => API.get(`${base}/calls/${callId}/status`);
// "Am I still on a call?" — asked on page load so a reload resumes the live
// call instead of offering a Call button that would dial the customer twice.
export const fetchActiveCall = () => API.get(`${base}/calls/active`);
export const cancelCall = (callId) => API.post(`${base}/calls/${callId}/cancel`);
export const setCallDisposition = (callId, data) => API.post(`${base}/calls/${callId}/disposition`, data);
export const fetchCalls = (params) => API.get(`${base}/calls`, { params });
// Your own dialled calls whose outcome was never recorded. Under a
// result-saved target rule these have earned nothing yet, so the rep is nudged.
export const fetchPendingResultCalls = (params) => API.get(`${base}/calls/pending-result`, { params });
export const fetchLeadCalls = (leadId, params) => API.get(`${base}/leads/${leadId}/calls`, { params });

// ── Devices ──
export const fetchMyDevice = () => API.get(`${base}/device/me`);
export const fetchDevices = (params) => API.get(`${base}/devices`, { params });
export const setDeviceStatus = (id, status) => API.patch(`${base}/devices/${id}/status`, { status });

// ── Analytics & targets ──
export const fetchCallSummary = (params) => API.get(`${base}/analytics/summary`, { params });
export const fetchCallsByRep = (params) => API.get(`${base}/analytics/by-rep`, { params });
export const fetchCallTimeSeries = (params) => API.get(`${base}/analytics/time-series`, { params });
export const fetchMyCallStats = (params) => API.get(`${base}/analytics/my`, { params });
export const fetchCallTargets = () => API.get(`${base}/targets`);
export const saveCallTarget = (data) => API.put(`${base}/targets`, data);
